/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListCars200Response,
  ShowCar200Response,
} from '../models/index';
import {
    ListCars200ResponseFromJSON,
    ListCars200ResponseToJSON,
    ShowCar200ResponseFromJSON,
    ShowCar200ResponseToJSON,
} from '../models/index';

export interface CreateCarRequest {
    make: string;
    model: string;
    year: number;
    nickname?: string | null;
    intro?: string | null;
    summary?: string | null;
    photos?: Array<Blob>;
    isPublic?: boolean;
    garageId?: number;
}

export interface DeleteCarRequest {
    id: number;
}

export interface FavoriteCarRequest {
    carId: number;
}

export interface ShowCarRequest {
    id: number;
}

export interface UnfavoriteCarRequest {
    carId: number;
}

export interface UpdateCarRequest {
    id: number;
    nickname?: string | null;
    intro?: string | null;
    summary?: string | null;
    make?: string;
    model?: string;
    year?: number;
    isPublic?: boolean;
    photoUrls?: Array<string>;
    photos?: Array<Blob>;
    garageId?: number;
}

/**
 * CarsApi - interface
 * 
 * @export
 * @interface CarsApiInterface
 */
export interface CarsApiInterface {
    /**
     * Accepts multipart form-data. Upload photos via `photos[]`. The car goes into the garage given by `garage_id`, or your first garage when that is left out.
     * @summary Create car
     * @param {string} make Must not be greater than 255 characters.
     * @param {string} model Must not be greater than 255 characters.
     * @param {number} year Must be at least 1900. Must not be greater than 2100.
     * @param {string} [nickname] Must not be greater than 255 characters.
     * @param {string} [intro] Must not be greater than 255 characters.
     * @param {string} [summary] 
     * @param {Array<Blob>} [photos] Must be an image. Must not be greater than 10240 kilobytes.
     * @param {boolean} [isPublic] 
     * @param {number} [garageId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarsApiInterface
     */
    createCarRaw(requestParameters: CreateCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Accepts multipart form-data. Upload photos via `photos[]`. The car goes into the garage given by `garage_id`, or your first garage when that is left out.
     * Create car
     */
    createCar(requestParameters: CreateCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete car
     * @param {number} id The ID of the car.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarsApiInterface
     */
    deleteCarRaw(requestParameters: DeleteCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * 
     * Delete car
     */
    deleteCar(requestParameters: DeleteCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Favorite car
     * @param {number} carId The ID of the car.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarsApiInterface
     */
    favoriteCarRaw(requestParameters: FavoriteCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * 
     * Favorite car
     */
    favoriteCar(requestParameters: FavoriteCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary List cars
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarsApiInterface
     */
    listCarsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCars200Response>>;

    /**
     * 
     * List cars
     */
    listCars(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCars200Response>;

    /**
     * 
     * @summary Show car
     * @param {number} id The ID of the car.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarsApiInterface
     */
    showCarRaw(requestParameters: ShowCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowCar200Response>>;

    /**
     * 
     * Show car
     */
    showCar(requestParameters: ShowCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowCar200Response>;

    /**
     * 
     * @summary Unfavorite car
     * @param {number} carId The ID of the car.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarsApiInterface
     */
    unfavoriteCarRaw(requestParameters: UnfavoriteCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * 
     * Unfavorite car
     */
    unfavoriteCar(requestParameters: UnfavoriteCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Accepts multipart form-data. `garage_id` moves the car to another of your garages. `photo_urls[]` is the list of existing photo URLs to KEEP (anything in the current `photo_urls` array that isn\'t in this list gets dropped). `photos[]` is new files to append.
     * @summary Update car
     * @param {number} id The ID of the car.
     * @param {string} [nickname] Must not be greater than 255 characters.
     * @param {string} [intro] Must not be greater than 255 characters.
     * @param {string} [summary] 
     * @param {string} [make] Must not be greater than 255 characters.
     * @param {string} [model] Must not be greater than 255 characters.
     * @param {number} [year] Must be at least 1900. Must not be greater than 2100.
     * @param {boolean} [isPublic] 
     * @param {Array<string>} [photoUrls] 
     * @param {Array<Blob>} [photos] Must be an image. Must not be greater than 10240 kilobytes.
     * @param {number} [garageId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarsApiInterface
     */
    updateCarRaw(requestParameters: UpdateCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Accepts multipart form-data. `garage_id` moves the car to another of your garages. `photo_urls[]` is the list of existing photo URLs to KEEP (anything in the current `photo_urls` array that isn\'t in this list gets dropped). `photos[]` is new files to append.
     * Update car
     */
    updateCar(requestParameters: UpdateCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class CarsApi extends runtime.BaseAPI implements CarsApiInterface {

    /**
     * Accepts multipart form-data. Upload photos via `photos[]`. The car goes into the garage given by `garage_id`, or your first garage when that is left out.
     * Create car
     */
    async createCarRaw(requestParameters: CreateCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['make'] == null) {
            throw new runtime.RequiredError(
                'make',
                'Required parameter "make" was null or undefined when calling createCar().'
            );
        }

        if (requestParameters['model'] == null) {
            throw new runtime.RequiredError(
                'model',
                'Required parameter "model" was null or undefined when calling createCar().'
            );
        }

        if (requestParameters['year'] == null) {
            throw new runtime.RequiredError(
                'year',
                'Required parameter "year" was null or undefined when calling createCar().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['nickname'] != null) {
            formParams.append('nickname', requestParameters['nickname'] as any);
        }

        if (requestParameters['intro'] != null) {
            formParams.append('intro', requestParameters['intro'] as any);
        }

        if (requestParameters['summary'] != null) {
            formParams.append('summary', requestParameters['summary'] as any);
        }

        if (requestParameters['make'] != null) {
            formParams.append('make', requestParameters['make'] as any);
        }

        if (requestParameters['model'] != null) {
            formParams.append('model', requestParameters['model'] as any);
        }

        if (requestParameters['year'] != null) {
            formParams.append('year', requestParameters['year'] as any);
        }

        if (requestParameters['photos'] != null) {
            requestParameters['photos'].forEach((element) => {
                formParams.append('photos', element as any);
            })
        }

        if (requestParameters['isPublic'] != null) {
            formParams.append('is_public', requestParameters['isPublic'] as any);
        }

        if (requestParameters['garageId'] != null) {
            formParams.append('garage_id', requestParameters['garageId'] as any);
        }


        let urlPath = `/api/v1/cars`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Accepts multipart form-data. Upload photos via `photos[]`. The car goes into the garage given by `garage_id`, or your first garage when that is left out.
     * Create car
     */
    async createCar(requestParameters: CreateCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createCarRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * Delete car
     */
    async deleteCarRaw(requestParameters: DeleteCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteCar().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/cars/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * Delete car
     */
    async deleteCar(requestParameters: DeleteCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCarRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * Favorite car
     */
    async favoriteCarRaw(requestParameters: FavoriteCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['carId'] == null) {
            throw new runtime.RequiredError(
                'carId',
                'Required parameter "carId" was null or undefined when calling favoriteCar().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/cars/{car_id}/favorite`;
        urlPath = urlPath.replace(`{${"car_id"}}`, encodeURIComponent(String(requestParameters['carId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * Favorite car
     */
    async favoriteCar(requestParameters: FavoriteCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.favoriteCarRaw(requestParameters, initOverrides);
    }

    /**
     * 
     * List cars
     */
    async listCarsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCars200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/cars`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListCars200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     * List cars
     */
    async listCars(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCars200Response> {
        const response = await this.listCarsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     * Show car
     */
    async showCarRaw(requestParameters: ShowCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowCar200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling showCar().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/cars/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowCar200ResponseFromJSON(jsonValue));
    }

    /**
     * 
     * Show car
     */
    async showCar(requestParameters: ShowCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowCar200Response> {
        const response = await this.showCarRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * Unfavorite car
     */
    async unfavoriteCarRaw(requestParameters: UnfavoriteCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['carId'] == null) {
            throw new runtime.RequiredError(
                'carId',
                'Required parameter "carId" was null or undefined when calling unfavoriteCar().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/cars/{car_id}/favorite`;
        urlPath = urlPath.replace(`{${"car_id"}}`, encodeURIComponent(String(requestParameters['carId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * Unfavorite car
     */
    async unfavoriteCar(requestParameters: UnfavoriteCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unfavoriteCarRaw(requestParameters, initOverrides);
    }

    /**
     * Accepts multipart form-data. `garage_id` moves the car to another of your garages. `photo_urls[]` is the list of existing photo URLs to KEEP (anything in the current `photo_urls` array that isn\'t in this list gets dropped). `photos[]` is new files to append.
     * Update car
     */
    async updateCarRaw(requestParameters: UpdateCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCar().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("default", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['nickname'] != null) {
            formParams.append('nickname', requestParameters['nickname'] as any);
        }

        if (requestParameters['intro'] != null) {
            formParams.append('intro', requestParameters['intro'] as any);
        }

        if (requestParameters['summary'] != null) {
            formParams.append('summary', requestParameters['summary'] as any);
        }

        if (requestParameters['make'] != null) {
            formParams.append('make', requestParameters['make'] as any);
        }

        if (requestParameters['model'] != null) {
            formParams.append('model', requestParameters['model'] as any);
        }

        if (requestParameters['year'] != null) {
            formParams.append('year', requestParameters['year'] as any);
        }

        if (requestParameters['isPublic'] != null) {
            formParams.append('is_public', requestParameters['isPublic'] as any);
        }

        if (requestParameters['photoUrls'] != null) {
            formParams.append('photo_urls', requestParameters['photoUrls']!.join(runtime.COLLECTION_FORMATS["csv"]));
        }

        if (requestParameters['photos'] != null) {
            requestParameters['photos'].forEach((element) => {
                formParams.append('photos', element as any);
            })
        }

        if (requestParameters['garageId'] != null) {
            formParams.append('garage_id', requestParameters['garageId'] as any);
        }


        let urlPath = `/api/v1/cars/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Accepts multipart form-data. `garage_id` moves the car to another of your garages. `photo_urls[]` is the list of existing photo URLs to KEEP (anything in the current `photo_urls` array that isn\'t in this list gets dropped). `photos[]` is new files to append.
     * Update car
     */
    async updateCar(requestParameters: UpdateCarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCarRaw(requestParameters, initOverrides);
    }

}
